import Image from "next/image";
import dragonlordslair from "public/images/DragonlordsLair.png";
import tint from "public/images/Tintagel.png";
import windvane from "public/images/WindVane.png";
import alphaavatars from "public/images/alpha-avatars.png";
import betaavatars from "public/images/beta-avatars.png";
import sk from "public/images/sk.webp";
import skart from "public/images/skart.png";

import {
  DoomLayoutSection,
  ExternalLink,
  H3,
  InternalLink,
  Line,
  OnClickLink,
  P,
  useBreakpoints,
} from "@sorcery/ui";

import { ModalTypeEnum, useModal } from "~/providers/ModalProvider";
import { alphaPath, arthurianPath, betaPath, dragonlordPath, shopPath } from "~/utils/paths";

export const BecomeARetailerProductTab = () => {
  const { openModal } = useModal();
  const { isSm } = useBreakpoints();

  return (
    <div className="duration-1000 animate-in fade-in">
      <P className="hidden pb-12 pt-1 sm:block sm:pb-4">
        <em>Sorcery: Contested Realm</em>
        <span>
          &nbsp;is a trading card game showcasing immersive and highly tactical gameplay,
          hand-illustrated artwork, and a return to the core elements that made TCGs so popular. The
          game is at its best in open play, inviting both players and spectators to lose themselves
          in the unfolding story. As a retailer, you'll have everything you need to support a
          thriving local community of Sorcerers.
        </span>
      </P>

      <InternalLink href={dragonlordPath}>
        <div className="cursor-pointer transition duration-300 hover:scale-[1.02] hover:opacity-50">
          <DoomLayoutSection
            bg={dragonlordslair}
            darken={false}
            gradient={false}
            smooshRight={!isSm}
            className="mb-20 gradient-mask-b-90 sm:mb-8"
            left={
              <div className="sm:my-4">
                <H3 className="!mb-4 text-center !text-2xl text-big-text-color sm:mt-0 sm:text-left">
                  Dragonlord
                </H3>
                <Line className="mb-1 mt-2" />
                <Line className="mb-4" />

                <P className="!mb-2">Coming soon...</P>
              </div>
            }
            right={<div className="h-48" />}
          />
        </div>
      </InternalLink>

      <InternalLink href={`${arthurianPath}?tab=product`}>
        <div className="cursor-pointer transition duration-300 hover:scale-[1.02] hover:opacity-50">
          <DoomLayoutSection
            bg={tint}
            darken={false}
            gradient={false}
            smooshRight={!isSm}
            className="mb-20 gradient-mask-b-90 sm:mb-8"
            left={
              <div className="sm:my-4">
                <H3 className="!mb-4 text-center !text-2xl text-big-text-color sm:mt-0 sm:text-left">
                  Arthurian Legends
                </H3>
                <Line className="mb-1 mt-2" />
                <Line className="mb-4" />

                <P className="!mb-2">Released October 2024</P>

                <ul className="ml-10 list-outside list-disc">
                  <li className="mb-1">Booster Box (SCRAL)</li>
                  <li className="mb-1">Valley of Delight Playmat (SCRMAT11)</li>
                </ul>
              </div>
            }
            right={<div className="h-28" />}
          />
        </div>
      </InternalLink>

      <InternalLink href={`${betaPath}?tab=product`}>
        <div className="cursor-pointer transition duration-300 hover:scale-[1.02] hover:opacity-50">
          <DoomLayoutSection
            bg={betaavatars}
            darken={false}
            gradient={false}
            smooshRight={!isSm}
            className="mb-20 gradient-mask-b-90 sm:mb-8"
            left={
              <>
                <H3 className="!mb-4 text-center !text-2xl text-big-text-color sm:mt-0 sm:text-left">
                  Beta Edition
                </H3>
                <Line className="mb-1" />
                <Line className="mb-4" />

                <P className="!mb-2">Released November 2023</P>
                <ul className="ml-10 list-outside list-disc">
                  <li className="mb-1">Booster Box (SCRB2)</li>
                  <li className="mb-1">Elemental Precon Decks (SCRB1)</li>
                  <li className="mb-1">Battlefield Playmat (SCRB4)</li>
                </ul>
              </>
            }
            right={<div className="h-28" />}
          />
        </div>
      </InternalLink>

      <InternalLink href={`${alphaPath}?tab=product`}>
        <div className="cursor-pointer transition duration-300 hover:scale-[1.02] hover:opacity-50">
          <DoomLayoutSection
            bg={alphaavatars}
            darken={false}
            gradient={false}
            smooshRight={!isSm}
            className="mb-20 gradient-mask-b-90 sm:mb-8"
            left={
              <>
                <H3 className="!mb-4 text-center !text-2xl text-big-text-color sm:text-left">
                  Alpha Edition
                </H3>
                <Line className="mb-1" />
                <Line className="mb-4" />

                <P className="!mb-2">Released June 2023</P>

                <ul className="ml-10 list-outside list-disc">
                  <li className="mb-1">Booster Box</li>
                  <li className="mb-1">Elemental Precon Decks</li>
                  <li className="mb-1">Kickstarter Exclusive</li>
                </ul>
              </>
            }
            right={<div className="h-28" />}
          />
        </div>
      </InternalLink>

      {/* <Line className="my-12" /> */}
      {/* <div className="max-w-xs">
        <H3 className="!mb-4 text-center !text-2xl text-big-text-color sm:mt-0 sm:text-left">
          Evergreen Products
        </H3>
        <Line className="mb-1" />
        <Line className="mb-4" />
      </div> */}

      <ExternalLink href={shopPath} target="_blank">
        <div className="cursor-pointer transition duration-300 hover:scale-[1.02] hover:opacity-50">
          <DoomLayoutSection
            bg={windvane}
            darken={false}
            gradient={false}
            smooshRight={!isSm}
            className="mb-20 gradient-mask-b-90 sm:mb-8"
            left={
              <>
                <H3 className="!mb-4 text-center !text-2xl text-big-text-color sm:text-left">
                  Draft Kit
                </H3>
                <Line className="mb-1" />
                <Line className="mb-4" />

                <P className="!mb-2">Available Online</P>
                <P>
                  With 48 basic sites and 4 copies of the Spellslinger Avatar, this kit enhances
                  Sorcery’s limited play, providing all the essentials you need to run a draft pod
                  or sealed event.
                </P>
              </>
            }
            right={<div className="h-28" />}
          />
        </div>
      </ExternalLink>

      <OnClickLink
        onClick={() =>
          openModal(ModalTypeEnum.CONTENT, {
            children: <Image src={sk} alt={"Store Kit"} className="lg:p-12" />,
          })
        }
      >
        <div className="cursor-pointer transition duration-300 hover:scale-[1.02] hover:opacity-50">
          <DoomLayoutSection
            bg={skart}
            darken={false}
            gradient={false}
            smooshRight={!isSm}
            className="mb-20 gradient-mask-b-90 sm:mb-8"
            left={
              <>
                <H3 className="!mb-4 text-center !text-2xl text-big-text-color sm:text-left">
                  Store Kit
                </H3>
                <Line className="mb-1" />
                <Line className="mb-4" />

                <P className="!mb-2">Available Through Regular Distribution Channels</P>
                <P>
                  <span>
                    Access the Store Kit designed for “Brick and Mortar” stores around the world.
                    Bring in hordes of players with&nbsp;
                  </span>
                  <em>The Champion</em>
                  <span>&nbsp;card up for grabs, together with other exclusive items.</span>
                </P>
              </>
            }
            right={<div className="h-28" />}
          />
        </div>
      </OnClickLink>
    </div>
  );
};
